export var ScriptOption;
(function (ScriptOption) {
    ScriptOption["ADD_DEFAULT_ORDER_SETTINGS"] = "addDefaultOrderSettings";
    ScriptOption["ADD_DRAFT_WAYPOINT_SUPPLY_STRATEGY"] = "addDraftWaypointSupplyStrategy";
    ScriptOption["ALGOLIA_UPDATE"] = "algoliaUpdate";
    ScriptOption["BATCH_SKU_IMPORT"] = "batchSkuImport";
    ScriptOption["CREATE_INSURANCE_PROVIDERS"] = "createInsuranceProviders";
    ScriptOption["DOWNLOAD_INSURANCES"] = "downloadInsurances";
    ScriptOption["FIX_NURSE_SHIFT_SETTINGS_LOCATIONS"] = "fixNurseShiftSettingsLocations";
    ScriptOption["GENERATE_DENORMALIZED_ORDERS"] = "generateDenormalizedOrders";
    ScriptOption["GENERATE_IDS"] = "generateIDs";
    ScriptOption["GEOHASHES"] = "geohashes";
    ScriptOption["ICD_10_CODE_IMPORT"] = "ICD10CodeImport";
    ScriptOption["MARK_DRAFT_WAYPOINTS_THAT_WERE_FINALIZED_MANUALLY"] = "markDraftWaypointsThatWereFinalizedManually";
    ScriptOption["MOVE_SHIPMENTS_AND_ADD_TYPE"] = "moveShipmentsAndAddType";
    ScriptOption["MOVE_TASK_TYPE_LICENSES_TO_TASK"] = "moveTaskTypeLicensesToTask";
    ScriptOption["NURSE_IMPORT"] = "nurseImport";
    ScriptOption["ASSISTANT_NOTIFICATION_SUBSCRIPTIONS"] = "assistantNotificationSubscriptions";
    ScriptOption["POSTAL_CODES"] = "postalCodes";
    ScriptOption["PROCEDURE_LAB_ORDER_UPDATE"] = "procedureLabOrderUpdate";
    ScriptOption["PRODUCT_CONFIG_DEFAULT_VALUES_REFACTOR"] = "productConfigDefaultValuesRefactor";
    ScriptOption["PRODUCT_CONFIG_TYPE_REFACTOR"] = "productConfigTypeRefactor";
    ScriptOption["PRODUCT_PLACE_GROUPS"] = "productPlaceGroups";
    ScriptOption["REMOVE_INSURANCES"] = "removeInsurances";
    ScriptOption["SERVICE_REGION_PRICING"] = "serviceRegionPricing";
    ScriptOption["SUPPLY_ITEM_IMPORT"] = "supplyItemImport";
    ScriptOption["TUBE_CONFIG_TYPE_REFACTOR"] = "tubeConfigTypeRefactor";
    ScriptOption["UPDATE_DRAFT_ORDERS"] = "updateDraftOrders";
    ScriptOption["UPDATE_ENCRYPTION"] = "updateEncryption";
    ScriptOption["UPDATE_NURSE_STRIPE_ACCOUNTS"] = "updateNurseStripeAccounts";
    ScriptOption["UPDATE_OFFICE_TYPES"] = "updateOfficeTypes";
    ScriptOption["UPDATE_OFFICE_PLACE_ACCOUNTS"] = "updateOfficePlaceAccounts";
    ScriptOption["UPDATE_PLACE_GROUP_SAMPLE_PAYMENT"] = "updatePlaceGroupSamplePayment";
    ScriptOption["UPDATE_PLACE_GROUP_TYPE_KIND"] = "updatePlaceGroupTypeKind";
    ScriptOption["UPDATE_USER_NOTIFICATION_SUBSCRIPTIONS"] = "updateUserNotificationSubscriptions";
    ScriptOption["UPDATE_USER_LAB_OFFICES"] = "updateUserLabOffices";
    ScriptOption["USERS_WALLET_UPDATE"] = "usersWalletUpdate";
})(ScriptOption || (ScriptOption = {}));
//# sourceMappingURL=scriptMaps.js.map